import { v4 as uuidv4 } from 'uuid'

const postKassaWebMessage = (type, data) => {
	if (!window.ReactNativeWebView) {
		return
	}
	const message = {
		eventId: uuidv4(),
		traceId: uuidv4(),
		type,
		context: 'kassa-web',
		eventTime: new Date().toISOString(),
		data,
	}
	window.ReactNativeWebView.postMessage(JSON.stringify(message))
}

export const buildCredentialsKey = (companyIndex, email) => `${companyIndex?.trim()}:${email?.trim()}`

export const buildCredentialsBlob = (password) => JSON.stringify({ password })

export const parseCredentialsBlob = (blob) => {
	if (!blob) {
		return null
	}
	try {
		return JSON.parse(blob)
	} catch (e) {
		return null
	}
}

export const requestSavedCredentials = (key) => {
	postKassaWebMessage('kassa-web.SAVED_CREDENTIALS_REQUESTED', key ? { key } : {})
}

export const publishLoginSucceeded = (key, blob) => {
	postKassaWebMessage('kassa-web.LOGIN_SUCCEEDED', { key, blob })
}
